import { render, staticRenderFns } from "./OzPlainButton.vue?vue&type=template&id=7424c2b4&"
import script from "./OzPlainButton.vue?vue&type=script&lang=ts&"
export * from "./OzPlainButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports